module.exports = __webpack_public_path__ + "static/ortadogu2-3fe7ef6211b2d3030a0861b7ff857f82.png";